import { useEffect, useState } from 'react'
import MainProfile from './main/MainProfile'
import ProfileModal from './main/modal'
import IconWhite from '../../../assets/svgs/IconWhite'
import style from './main/MainProfile.module.css'
import { useProfileContext } from '../../../contexts/ProfileContext'
import layout from './ProfileTab.module.css'

const ProfileTab = () => {
  const [modalTitle, setModalTitle] = useState('')
  const [selectedId, setSelectedId] = useState('')
  const [openModal, setOpenModal] = useState(false)
  const [create, setCreate] = useState(false)
  const owner = true
  const [editMode, setEditMode] = useState(false)

  const { userProfile, setUserProfile, fetchProfile, loading } =
    useProfileContext()

  useEffect(() => {
    fetchProfile()
  }, [fetchProfile])

  if (userProfile === null) {
    return (
      <div className={style.loading}>
        <IconWhite color={'#432c5b'} width={100} stroke={0.5} />
      </div>
    )
  }

  const toggleModal = (value, item, create) => {
    setOpenModal(!openModal)
    setModalTitle(value)
    setSelectedId(item)
    if (create !== undefined) setCreate(true)
  }

  const editModelToggle = () => setEditMode((prev) => !prev)

  if (loading) return <p>Loading profile...</p>
  if (!userProfile) return <p>No profile data available.</p>

  return (
    <div className={layout.profileDashboard}>
      <main className={layout.centerCol}>
        <MainProfile
          userProfile={userProfile}
          toggleModal={toggleModal}
          openModal={openModal}
          owner={owner}
          editMode={editMode}
          editModelToggle={editModelToggle}
        />

        <ProfileModal
          toggleModal={toggleModal}
          openModal={openModal}
          modalTitle={modalTitle}
          userProfile={userProfile}
          setUserProfile={setUserProfile}
          selectedId={selectedId}
          create={create}
        />
      </main>
    </div>
  )
}

export default ProfileTab
